/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "at-b6d3bd9b--sprite",
  "use": "at-b6d3bd9b--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"at-b6d3bd9b--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(9165 18078)\"><g transform=\"translate(-9155.103 -18068.102)\"><g transform=\"translate(0 0)\" style=\"isolation:isolate\"><path d=\"M31.574,347.813a6.455,6.455,0,0,1,6.8,6.842c0,3.517-2.364,5.285-4.381,5.285a2.091,2.091,0,0,1-2.21-1.461h-.038a3.112,3.112,0,0,1-2.306,1.268c-1.518,0-2.537-1.114-2.537-2.882,0-2.345,1.673-4.709,3.883-4.709a1.5,1.5,0,0,1,1.46.961h.039l.269-.807H34.3l-.884,4.228c-.269,1.114.019,1.652.884,1.652,1.153,0,2.287-1.345,2.287-3.459,0-2.748-1.48-5.208-5.247-5.208a6.813,6.813,0,0,0-6.535,7.13,5.268,5.268,0,0,0,5.612,5.612,6.71,6.71,0,0,0,2.921-.75l.615,1.538a7.706,7.706,0,0,1-3.767.922c-3.843,0-7.284-2.344-7.284-7.245A8.552,8.552,0,0,1,31.574,347.813ZM30.037,357.98c.4,0,.787-.231,1.268-.865l.461-2.595a.962.962,0,0,0-.884-.557c-1.153,0-1.845,1.576-1.845,2.729C29.037,357.557,29.4,357.98,30.037,357.98Z\" transform=\"translate(-22.906 -347.813)\" fill=\"currentColor\" /></g></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
